import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const OfficeHoursService = {

    getSettings: (account: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-horary/${account}`);
    },
    
    updateOfficeHours: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-horary-attention`, data );
    },
    
    updateSettings: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-setting-horary-attention`, data );
    },
   
}